import { createFileRoute } from '@tanstack/react-router';
import { SuppliersDirectoryPage } from '@/features/purchasing/SuppliersDirectory';
export const Route = createFileRoute('/_dashboard/dashboard/purchasing/suppliers/')({
  component: SuppliersDirectoryPage,
});
